export default __webpack_public_path__ + "static/media/ic-failed.1b70a12d.svg";